module.exports = __webpack_public_path__ + "bc833e725c137257c2c42a789845d82f.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-900italic.woff
// module id = 678
// module chunks = 0